import Chip, { ChipColor, Props as ChipProps } from './Chip';

export type ChipStatus =
  | 'error'
  | 'fail'
  | 'warn'
  | 'warning'
  | 'partial success'
  | 'success'
  | 'idle'
  | 'open'
  | 'close'
  | 'merged'
  | 'pass'
  | 'passed'
  | 'no_data'
  | 'noData'
  | 'not_found'
  | 'skipped'
  | 'skip'
  | 'high'
  | 'medium'
  | 'low'
  | 'none'
  | 'runtime_error'
  | 'verified'
  | 'pending_verification'
  | 'active'
  | 'pending'
  | 'resolved';

const chipStatusMap = {
  error: { label: 'Error', color: 'error' },
  fail: { label: 'Failure', color: 'error' },
  warn: { label: 'Warning', color: 'warning' },
  warning: { label: 'Warning', color: 'warning' },
  'partial success': { label: 'Partial Success', color: 'warning' },
  success: { label: 'Success', color: 'success' },
  pass: { label: 'Passed', color: 'success' },
  passed: { label: 'Passed', color: 'success' },
  no_data: { label: 'No data', color: 'default' },
  noData: { label: 'No data', color: 'default' },
  skipped: { label: 'Skipped', color: 'default' },
  skip: { label: 'Skipped', color: 'default' },
  high: { label: 'High', color: 'success' },
  medium: { label: 'Medium', color: 'warning' },
  idle: { label: 'Idle', color: 'idle' },
  open: { label: 'Open', color: 'success' },
  not_found: { label: 'Not found', color: 'error' },
  close: { label: 'Close', color: 'idle' },
  merged: { label: 'Merged', color: 'merged' },
  low: { label: 'Low', color: 'error' },
  runtime_error: { label: 'Runtime Error', color: 'error' },
  verified: { label: 'Verified', color: 'success' },
  pending_verification: { label: 'Pending', color: 'warning' },
  active: { label: 'Active', color: 'success' },
  pending: { label: 'Pending', color: 'default' },
  resolved: { label: 'Resolved', color: 'success' },
} as { [key in ChipStatus]: { label: string; color: ChipColor } };

type Props = ChipProps & {
  status: ChipStatus;
  capitalize?: boolean;
};

const StatusChip = ({ status, capitalize, ...rest }: Props) => (
  <Chip
    label={
      capitalize
        ? chipStatusMap[status].label?.toUpperCase()
        : chipStatusMap[status].label
    }
    color={chipStatusMap[status].color}
    {...rest}
  />
);

export default StatusChip;
